import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface PrimerAssemblyMismatchRowProps {
  fragmentResultColor: string;
  fragmentSequenceName: string;
  fragmentSequenceID: string;
  newBase: string;
  originalBase: string;
  pos: string;
  showPrintableSummary: boolean;
}

function PrimerAssemblyMismatchRow({
  fragmentResultColor,
  fragmentSequenceName,
  fragmentSequenceID,
  newBase,
  originalBase,
  pos,
  showPrintableSummary,
}: PrimerAssemblyMismatchRowProps): JSX.Element {
  return (
    <>
      <td>{pos}</td>
      <td
        style={{[showPrintableSummary ? 'borderLeftColor' : 'backgroundColor']: fragmentResultColor}}
        className="printable-color"
      >
        {fragmentSequenceID ? (
          <a data-fragment-sequence-id={fragmentSequenceID} className="js-fragment-sequence">
            {fragmentSequenceName}
          </a>
        ) : (
          fragmentSequenceName
        )}
      </td>
      <td>{originalBase}</td>
      <td>{newBase}</td>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<PrimerAssemblyMismatchRowProps>(PrimerAssemblyMismatchRow);
